module.exports = __webpack_public_path__ + "static/media/YM66_2.d38b301a.jpg";